export default __webpack_public_path__ + "static/media/sc2.9c9b9ac3.png";